import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SilverZakatTable from "./SilverZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Silver_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حساب زكاة الفضة 2026 - حاسبة نصاب زكاة الفضة";
const DESCRIPTION =
  "حاسبة زكاة الفضة هي أداة تستخدم لحساب مبلغ زكاة الفضة المستحقة وفقًا للأحكام الشرعية في الإسلام. تستخدم هذه الحاسبة لحساب المبلغ المالي الذي يجب دفعه كزكاة على الفضة المملوكة.";
const KEYWORDS = "زكاة الفضة, إحسب زكاة الفضة ";
const OG_URL = "https://do-calculate.com/calculator/ar/silver-zakat/";
const apiEndpoint = `${SERVER_URL}/${Silver_Zakat_EndPoint}`;
function SilverZakatCalculator() {
  const [yearType, setYearType] = useState("");
  const [gramPriceSilver, setGramPriceSilver] = useState(0);
  const [silverWeight, setSilverWeight] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleSilverWeightChange = (event) => {
    setSilverWeight(event.target.value);
  };
  const handleYearTypeChange = (event) => {
    setYearType(event.target.value);
  };
  const handleGramPriceSilverChange = (event) => {
    setGramPriceSilver(event.target.value);
  };
  const calculateSilverZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ silverWeight, gramPriceSilver, yearType }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}> احسب زكاة الفضة لأي عيار </h1>
          </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    تعتمد عملية حساب زكاة الفضة على مجموعة من العوامل المهمة، بما في ذلك وزن الفضة وسعر الجرام. يجب أيضًا تحديد السنة الزمنية المستخدمة في الحساب، سواء كانت السنة الهجرية أو الميلادية.
                                </p>
                                <p>
                                    يتم تحديد العتبة الزكوية للفضة (nisab) التي تعادل 595 جرامًا. إذا كان وزن الفضة المتوفر لديك يتجاوز هذه العتبة، تصبح زكاة الفضة واجبة. يتم حساب قيمة الزكاة بناءً على نسبة مئوية محددة، حيث يتم استخدام نسبة زكاة الفطر البالغة 2.5٪ وفقًا للتقويم الهجري، أو نسبة 2.577٪ وفقًا للتقويم الميلادي، حسب السنة الزمنية المستخدمة.
                                </p>
                                <p>
                                    بعد حساب قيمة زكاة الفضة، يتم ضبط المبلغ بشكل دقيق لتحديد المبلغ النهائي المستحق. الحاسبة ستوفر لك النتائج النهائية في شكل تقرير يتضمن قيمة زكاة الفضة المستحقة، حالة الزكاة (مطلوبة أم لا)، العتبة الزكوية، والمبلغ المالي الناتج.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    زكاة الفضة
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >نوع الحول</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian" checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            ميلادي
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id="hijri" checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            هجري
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="silverWeightNumber" className="form-label ms-2">إجمالي وزن الفضة </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="silverWeightNumber"
                                        value={silverWeight}
                                        onChange={handleSilverWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">غ</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="gramPriceGoldNumber" className="form-label ms-2">سعر غرام الفضة (عيار 99.9)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceSilver}
                                        onChange={handleGramPriceSilverChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateSilverZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'إحسب'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">النتائج: </div></h4>
                                            <hr />
                                            <SilverZakatTable result={result}></SilverZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">وصف حاسبة زكاة الفضة</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>كيفية حساب زكاة الفضة</h2>
                                <br />
                                <p>
                                    تعتمد حاسبة زكاة الفضة على مجموعة من المتغيرات مثل وزن الفضة وسعر الجرام، بالإضافة إلى نوع السنة الزمنية (هجري أو ميلادي). يتم تحديد النصاب للفضة (العتبة الزكوية)، وهو 595 جرامًا وفقًا للمعايير الشرعية.
                                </p>
                                <br />
                                <p>
                                    إذا تجاوز وزن الفضة النصاب المحدد، تصبح زكاة الفضة واجبة. يتم احتساب قيمة زكاة الفضة باستخدام نسبة مئوية محددة، وهي 2.5% للزكاة الهجرية و2.577% للزكاة الميلادية، حسب السنة الزمنية.
                                </p>
                                <br />
                                <p>
                                    بعد حساب قيمة زكاة الفضة، يتم ضبط المبلغ بشكل مناسب للحصول على القيمة النهائية للزكاة والمبلغ المالي الواجب إخراجه.
                                </p>
                                <p>
                                    تقدم الحاسبة النتائج النهائية بشكل كائن يحتوي على مبلغ زكاة الفضة، حالة الزكاة (مستحقة أم لا)، النصاب، والمبلغ المالي النهائي.
                                </p>
                                <br />
                                <p>
                                    هذه الحاسبة صالحة للاستخدام في جميع الدول العربية، بما في ذلك:
                                </p>
                                <ul>
                                    <li>المملكة العربية السعودية</li>
                                    <li>الإمارات العربية المتحدة</li>
                                    <li>الكويت</li>
                                    <li>البحرين</li>
                                    <li>قطر</li>
                                    <li>عمان</li>
                                    <li>الأردن</li>
                                    <li>مصر</li>
                                    <li>العراق</li>
                                    <li>لبنان</li>
                                    <li>سوريا</li>
                                    <li>فلسطين</li>
                                    <li>اليمن</li>
                                    <li>المغرب</li>
                                    <li>الجزائر</li>
                                    <li>تونس</li>
                                    <li>ليبيا</li>
                                </ul>
                                <br />
                                <hr />
                                <b>المصدر: </b>
                                <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/" rel="nofollow noreferrer" target="_blank">
                                    الإغاثة الإسلامية عبر العالم
                                </a>
                                <br />
                                <b>تاريخ آخر مراجعة:</b> 28/02/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div> <br />
        </div>
    );
}
export default SilverZakatCalculator;
